<template>
    <div class="questionnaire-edit-nav-wrapper">
        <div
            class="questionnaire-edit-nav"
            role="tablist">
            <draggable
                group="navparts"
                :list="sectionsIn"
                handle=".questionnaire-drag-handle"
                @change="sectionOrderChanged()"
                ghost-class="ghost">
                <design-2021-questionnaire-edit-nav-item-component
                    v-for="section in sectionsIn"
                    :key="section.id"
                    @hold="hold($event)"
                    @continue="cont($event)"
                    :section-in="section"
                    @selected-questionnaire="
                        $emit('selected-questionnaire', $event);
                        selected = $event;
                    "
                    :selected="section.id === selected"></design-2021-questionnaire-edit-nav-item-component>
            </draggable>
        </div>
    </div>
</template>

<script>
import { ords } from '../../app';
import draggable from 'vuedraggable';

export default {
    name: 'design-2021-questionnaire-edit-nav-component',
    props: ['sectionsIn'],
    components: {
        draggable,
    },
    data() {
        return {
            holds: [],
            selected: null,
        };
    },
    methods: {
        sectionOrderChanged() {
            let array = [];
            let counter = 0;
            for (let section of this.questionnaire.sections) {
                counter++;
                section.order = counter;

                array.push({
                    id: section.id,
                    order: counter,
                });
            }

            const data = {
                questionnaire_id: this.questionnaire.id,
                sections: array,
            };

            this.axios.post(this.routes.questionnaireSectionOrder(), data).then(
                (response) => {
                    // no action required
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        hold(key) {
            for (const h of this.holds) {
                if (key === h) {
                    return;
                }
            }
            this.holds.push(key);
            ords.hold();
        },
        cont(key) {
            this.holds = this.holds.filter((k) => k !== key);
            if (!this.holds.length) {
                ords.continue();
            }
        },
    },
};
</script>

<style scoped lang="scss">
.ghost {
    background-color: darken($secondary-background-color, 10%);
}

.questionnaire-edit-nav-wrapper {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.add-questionnaire {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-add-questionnaire {
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }
}
</style>
